export const values = [
  {
    icon: "ri-compass-3-line",
    title: "网站定位",
    desc: "做一条低门槛、可信任的匿名信息通道。我们不追热点、不做标题党，只把有价值的事实送到该被看见的地方。",
  },
  {
    icon: "ri-seedling-line",
    title: "发展理念",
    desc: "保护投稿人和核实事实同样重要。宁可慢一点，也不为了抢时效而牺牲信息来源的安全。",
  },
  {
    icon: "ri-scales-3-line",
    title: "内容原则",
    desc: "以可核实的事实为基础，不做立场站队。涉及具体个人的指称，必须提供可查证的背景与时间线。",
  },
];

export const principles = [
  "最小信息原则：只处理核实所需的最少数据",
  "最小留存原则：超出必要周期即按流程清理",
  "按需授权原则：接触范围随处理环节逐级开放",
  "可追溯原则：每一次访问与流转都留有记录",
  "拒绝商业化原则：投稿内容不用于任何商业推广",
];

export const testimonials = [
  {
    quote:
      "我一直担心递交材料会被认出笔迹式的细节。在爆料51投稿时只留了代号，对方也只是通过代号回我，整个过程没有人问我是谁。",
    author: "匿名用户 A",
    role: "制造业 / 质量管理",
  },
  {
    quote:
      "之前试过几个渠道，都要手机号。这里连账号都不用注册，我把工作里看到的违规操作讲清楚就提交了，后来确实有跟进。",
    author: "匿名用户 B",
    role: "零售 / 门店运营",
  },
  {
    quote:
      "最打动我的是那句『不需要你解释你是谁』。我按要求去掉了所有能指向自己的细节，心里踏实了很多。",
    author: "匿名用户 C",
    role: "物流 / 调度",
  },
];

export const aboutStats = [
  { value: "2019", label: "通道开始运行" },
  { value: "6", label: "主要受理领域" },
  { value: "24", label: "小时接收投稿" },
  { value: "0", label: "强制实名门槛" },
];